import { ProductWithQuantity } from "@project/gas-warning-center-configuration/product-with-quantity";

export class OriginalRegard7000PlusConfiguration {
  dockingStations: ProductWithQuantity[];
  inputModules: ProductWithQuantity[];
  relayModules: ProductWithQuantity[];
  gatewayModules: ProductWithQuantity[];
  terminalBlocks: ProductWithQuantity[];
  dashboards: ProductWithQuantity[];

  constructor(
    dockingStations: ProductWithQuantity[],
    inputModules: ProductWithQuantity[],
    relayModules: ProductWithQuantity[],
    gatewayModules: ProductWithQuantity[],
    terminalBlocks: ProductWithQuantity[],
    dashboards: ProductWithQuantity[],
  ) {
    this.dockingStations = dockingStations;
    this.inputModules = inputModules;
    this.relayModules = relayModules;
    this.gatewayModules = gatewayModules;
    this.terminalBlocks = terminalBlocks;
    this.dashboards = dashboards;
  }
}
